import api from "@/services/api";

class DeleteAssociate {
  execute = async (associateId: string) => {
    const response = await api().delete(`/associate?associateId=${associateId}`);
    return response.data;
  };
}

export { DeleteAssociate };




